/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}modal-drawer`;
const classes = {
    DISPLAY_NONE: 'display-none',
    SCRIM_CLOSED: 'closed'
};
const events = {
    CLOSE: `${elementName}-close`
};
export const MODAL_DRAWER_CONSTANTS = {
    elementName,
    classes,
    events
};
